import * as React from 'react'
import type {SVGProps} from 'react'
const SvgClipboard = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={25}
        height={33}
        fill="none"
        viewBox="0 0 25 33"
        {...props}
    >
        <g clipPath="url(#clipboard_svg__a)">
            <path fill="#fff" d="M5.91 4.925h13.299v3.448H5.91z" />
            <path fill="#fff" d="M8.867 1.97h6.896v4.433H8.867zM1.969 6.896h21.179v24.627H1.969z" />
            <path
                fill="#000"
                d="M9.378 4.383a3.09 3.09 0 0 1 2.997-2.32c1.444 0 2.656.986 2.997 2.32.116.457.529.773 1 .773h1.16c.566 0 1.03.464 1.03 1.032V8.25H6.188V6.188c0-.568.464-1.032 1.03-1.032h1.16c.471 0 .884-.316 1-.773M12.375 0a5.16 5.16 0 0 0-4.724 3.094h-.432a3.1 3.1 0 0 0-2.92 2.062h-.174A4.13 4.13 0 0 0 0 9.281v19.594A4.13 4.13 0 0 0 4.125 33h16.5a4.13 4.13 0 0 0 4.125-4.125V9.281a4.13 4.13 0 0 0-4.125-4.125h-.174a3.1 3.1 0 0 0-2.92-2.062H17.1A5.16 5.16 0 0 0 12.375 0m8.25 7.219a2.06 2.06 0 0 1 2.063 2.062v19.594a2.06 2.06 0 0 1-2.063 2.063h-16.5a2.06 2.06 0 0 1-2.062-2.063V9.281A2.06 2.06 0 0 1 4.124 7.22V8.25a2.06 2.06 0 0 0 2.063 2.063h12.375a2.06 2.06 0 0 0 2.062-2.063zm-7.219-2.063a1.031 1.031 0 1 0-2.062 0 1.031 1.031 0 0 0 2.062 0m-2.365 10.01c.4-.4.4-1.057 0-1.457s-1.057-.4-1.457 0L7.22 16.075l-.819-.819c-.4-.4-1.057-.4-1.456 0-.4.4-.4 1.057 0 1.457L6.49 18.26c.4.4 1.057.4 1.457 0zm1.334 2.365c0 .567.464 1.032 1.031 1.032h4.125c.567 0 1.032-.465 1.032-1.032S18.098 16.5 17.53 16.5h-4.125c-.567 0-1.031.464-1.031 1.031m-2.062 6.188c0 .567.464 1.031 1.03 1.031h6.188c.567 0 1.032-.464 1.032-1.031s-.465-1.032-1.032-1.032h-6.187c-.567 0-1.031.465-1.031 1.032m-3.094 1.547a1.547 1.547 0 1 0 0-3.095 1.547 1.547 0 0 0 0 3.095"
            />
        </g>
        <defs>
            <clipPath id="clipboard_svg__a">
                <path fill="#fff" d="M0 0h24.75v33H0z" />
            </clipPath>
        </defs>
    </svg>
)
export default SvgClipboard
